import { IIndicatorData } from "./iindicator-data-strategy";
import { IndicatorData } from "./indicator-data";

export class TopTenProductsIndicatorData implements IIndicatorData {
  private readonly name: string = "TopTenProducts";

  constructor(private readonly items: IndicatorData[]) {}

  getName(): string {
    return this.name;
  }

  getTotal(): string {
    return this.items[0].getValue() as string;
  }

  getItems() {
    return this.items.slice(1).map((item) => {
      const indicatorItemName = item.getKey();

      const indicatorItemQuantityIndicatorData = item.getValue()[0] as IndicatorData;
      const indicatorItemQuantity = indicatorItemQuantityIndicatorData.getValue();

      const indicatorItemPercentageIndicatorData = item.getValue()[1] as IndicatorData;
      const indicatorItemPercentage = indicatorItemPercentageIndicatorData.getValue();

      return {
        indicatorItemName: indicatorItemName,
        indicatorItemQuantity: indicatorItemQuantity,
        indicatorItemPercentage: indicatorItemPercentage,
      };
    });
  }
}
